import { Button, Flex, Heading, VStack, Text, Image } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { CompleteTrainingContainer } from '../components/LandingPageComponents/styles/SplashStyles';
import badge from '../assets/badge.svg';
const UploadComPlete = () => {
    const navigate = useNavigate();

    return (
        <CompleteTrainingContainer>
            <Flex
                w={{ base: 'full', lg: '40%' }}
                mt={{ base: '0', lg: '10px' }}
                h="full"
                mx="auto"
                justify="center"
                alignItems="center"
                justifyContent="start"
                flexDir="column">
                <Heading
                    as="h2"
                    w="90%"
                    mt="20px"
                    mb="5px"
                    color="#090A0A"
                    fontSize={{ base: '24px', lg: '32px' }}
                    textAlign="center"
                    lineHeight={{ base: '32px', lg: '36px' }}>
                    Thank you For Completing this process
                </Heading>
                <Text
                    w="80%"
                    mt="1rem"
                    mb="2rem"
                    textAlign="center"
                    fontSize={{ base: '14px', lg: '16px' }}
                    lineHeight="20px">
                    Here’s a Detail of
                </Text>
                <VStack
                    w={{ base: '85%', lg: '311px' }}
                    borderRadius="16px"
                    px="1rem"
                    py="1.5rem"
                    minH="291px"
                    bg="white">
                    <Text
                        textTransform="uppercase"
                        mt="1rem"
                        textAlign="center"
                        fontSize="12px"
                        lineHeight="16px">
                        You are hereby Certified
                    </Text>
                    <Heading
                        as="h4"
                        mt="0"
                        mb="5px"
                        color="#090A0A"
                        fontSize="18px"
                        textAlign="center"
                        lineHeight="24px">
                        to sell on Obana{' '}
                    </Heading>
                    <Heading
                        as="h4"
                        pt="20px"
                        pb="15px"
                        w="75%"
                        color="#1b3b5f"
                        fontSize="48px"
                        textAlign="center"
                        lineHeight="56px">
                        <Image src={badge} mr="5px" />
                        Obana Certified
                    </Heading>
                    <Text textAlign="center" fontSize="14px" lineHeight="20px" pb="1rem">
                        Your Agent ID :<b> FAZ-4626</b>
                    </Text>

                    <Button
                        className="btn"
                        onClick={() => navigate('/dashboard/profile/user', { replace: true })}>
                        Proceed to Profile
                    </Button>
                </VStack>

                <Text
                    w={{ base: '80%', lg: '311px' }}
                    mt="10px"
                    fontSize="12px"
                    color="#6C7072"
                    textAlign="center">
                    A Terms and Conditions agreement outlines the terms that visitors must agree to
                    if they want to interact with your website.
                </Text>
            </Flex>
        </CompleteTrainingContainer>
    );
};

export default UploadComPlete;
